export type Option<V extends string = string> = {
  label: string;
  value: V;
};

export const createOption = <V extends string>(
  value: V,
  label: string = value,
): Option<V> => ({
  label,
  value,
});

export const createOptions = <V extends string>(
  items: [value: V, label?: string][],
): Option<V>[] => items.map(([value, label]) => createOption(value, label));
